import React, { useState, useEffect } from "react";
import {
  Button,
  Grid,
  FormControl,
  InputAdornment,
  InputLabel,
  OutlinedInput,
  Select,
  MenuItem,
  CircularProgress,
} from "@material-ui/core";
import { panelUsersAuthStyle } from "../../panelUsersAuthStyle";
import { useDispatch } from "react-redux";
import { EditarUbicaciones } from "../../../domain/api/UbicacionesApi";
import { Store } from "react-notifications-component";
import { getClientes } from "../../../domain/api/ClientesApi";
import { ROL_USER } from "../../../../app/api-client/constants";

export const EditUbicacion = ({ reload, clearData, data }) => {
  const classes = panelUsersAuthStyle();
  const [isLoading, setIsLoading] = useState(false); // Definimos isLoading
  const dispath = useDispatch();
  const [nombre, setNombre] = useState(data.value);
  const [, setNombreCliente] = useState(data.cliente.nombre);
  const [, setDocumento] = useState(data.documento);
  const [clientes, setClientes] = useState([]);
  const [asigCliente, setAsigCliente] = useState(data.cliente.id);


  const handleAlert = (title, message, type) => {
    Store.addNotification({
      title: title,
      message: message,
      type: type,
      insert: "top",
      container: "top-right",
      animationIn: ["animate__animated", "animate__fadeIn"],
      animationOut: ["animate__animated", "animate__fadeOut"],
      dismiss: {
        duration: 5000,
        onScreen: true,
      },
    });
    setTimeout(() => {
      clearData(false);
      reload("all", "", 0, 30)
    }, 1000);
  };

  const editarUbicacion = async (request) => {
    try {
      setIsLoading(true);
      const response = await EditarUbicaciones(dispath, request);

      if (response.success) {
        handleAlert("Ocurrió un error!", "Ocurrió un error al cambiar el estado", "danger");
      } else {
        handleAlert("Actualizado Exitosamente!", `${nombre} actualizado con éxito!`, "success");
      }
    } catch (error) {
      handleAlert("Ocurrió un error!", "Error interno", "danger");
    } finally {
      setIsLoading(false);
    }
  };

  const editar = () => {
    setIsLoading(true); // Cambiamos isLoading a true al hacer clic en el botón
    const request = {
      id: data.id,
      cliente: asigCliente,
      valor: nombre,
    };
    editarUbicacion(request);
  };

  useEffect(async () => {
    const users = await getClientes(dispath, "", 0, 30);
    setClientes(users.content);

  }, []);
  const rol = localStorage.getItem(ROL_USER);

  return (
    <form>
      <Grid container spacing={3} style={{ textAlign: "left" }}>
        <Grid item xs={12} md={12} sm={12}>
          <FormControl fullWidth variant="outlined">
            <InputLabel htmlFor="nombre">Nombre</InputLabel>
            <OutlinedInput
              id="nombre"
              type="nombre"
              name="nombre"
              defaultValue={nombre}
              required
              onChange={(e) => setNombre(e.target.value)}
              startAdornment={<InputAdornment position="start">-</InputAdornment>}
              labelWidth={100}
              style={{borderRadius:'10px'}}
            />
          </FormControl>
        </Grid>
        {rol=== 'ROLE_ADMIN'&&
        <Grid item xs={12} md={12} sm={12}>
          <FormControl fullWidth variant="outlined">
            <InputLabel htmlFor="Cliente" shrink style={{ fontWeight: "bold", fontSize: "18px" }}>
              Cliente*
            </InputLabel>
            <Select
              labelId="demo-simple-select-outlined-label"
              id="Cliente"
              name="Cliente"
              value={asigCliente}
              style={{ fontSize: "18px",borderRadius:'10px'}}
              onChange={(e) => setAsigCliente(e.target.value)}
              label="Cliente"
              startAdornment={<InputAdornment position="start">-</InputAdornment>}
            >
              <MenuItem value="">
                <em>Selecciona un Cliente</em>
              </MenuItem>

              {clientes.map((item) => (
                <MenuItem value={item.id} key={item.id}>
                  {item.nombre}
                </MenuItem>
              ))}
            </Select>
          </FormControl>
        </Grid>
        }
      </Grid>
      <div className={classes.wrapper}>
        <Grid container justifyContent="center" style={{ marginTop: "10px" }}>
          <Button
            type="button"
            variant="contained"
            color="primary"
            style={{ textTransform: "none", width: "40%",borderRadius:'10px' }}
            onClick={editar}
            disabled={isLoading} // Usamos isLoading para deshabilitar el botón mientras isLoading sea true
          >
            {isLoading ? <CircularProgress size={24} /> : "Editar"}
          </Button>
        </Grid>
      </div>
    </form>
  );
};
